export const AUDIENCE_POST_REFILL_PER_MINUTE = 2;
export const AUDIENCE_POST_BURST_CAPACITY = 3;
export const AUDIENCE_REPLY_REFILL_PER_MINUTE = 3;
export const AUDIENCE_REPLY_BURST_CAPACITY = 3;

type AudienceRateLimitKind = "messages" | "replies";

export function rateLimitErrorMessage(
  kind: AudienceRateLimitKind,
  retryAfterMs: number,
): string {
  return `Rate limit reached for ${kind}. Retry in ${Math.max(1, Math.ceil(retryAfterMs / 1_000))}s.`;
}

export function parseRateLimitError(
  text: string,
): { kind: AudienceRateLimitKind; retryAfterSeconds: number | null } | null {
  const match = text.match(
    /Rate limit reached for (messages|replies)\.(?: Retry in (\d+)s\.)?/,
  ) ?? text.match(
    /Max \d+ (messages|replies) per minute\.(?: Retry in (\d+)s\.)?/,
  );
  if (!match) return null;
  return {
    kind: match[1] as AudienceRateLimitKind,
    retryAfterSeconds: match[2] ? Number(match[2]) : null,
  };
}
